import { cva } from 'class-variance-authority';

export const resourceConvContainer = cva(
  'relative flex items-center rounded-lg px-6 py-8 @md:p-12 @lg:px-12 @lg:py-16',
  {
    variants: {
      theme: {
        dark: ['border-cardBorder border border-solid bg-resourceCardGradient p-3 text-white'],
        green: ['rounded-lg border-[1.5px] border-solid border-primary-200 bg-primary-50'],
      },
      variation: {
        form: ['dark-gradient-res-conversation-card'],
        basic: ['green-gradient-res-conversation-card'],
      },
    },
  },
);

export const headingStyles = cva('font-spaceGrotesk text-xl font-bold @lg:text-display-md @6xl:text-display-lg', {
  variants: {
    theme: {
      dark: 'resource-conv-heading-color text-transparent',
      green: 'text-gray-900',
    },
    variation: {
      form: 'resource-conv-heading-color text-transparent',
      basic: 'text-gray-900',
    },
  },
});

export const descriptionStyles = cva('text-md', {
  variants: {
    theme: {
      dark: 'text-gray-300',
      green: 'text-gray-700',
    },
    variation: {
      form: 'text-gray-300',
      basic: 'text-gray-700',
    },
  },
});
